import { Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { EnvService } from './env.service';
import { SsrService } from './ssr.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  isPostHogInitialized = false;

  identify(userId: string, properties?: Record<string, any>) {
    if(this.ssr.isPlatformServer())
      return;
    
    if(this.isPostHogInitialized){
      posthog.identify(userId, properties);
    }
  }

  reset(){
    if(this.ssr.isPlatformServer())
      return;

    if(this.isPostHogInitialized){
      posthog.reset();
    }
  }

  init(){
    if(this.ssr.isPlatformServer())
      return;

    this.ngZone.runOutsideAngular(() => {
      if(this.env.analyticsConfig.enabled){
        posthog.init(this.env.analyticsConfig.apiKey, { 
          api_host: this.env.analyticsConfig.apiBaseUrl, 
          defaults: '2026-01-30' 
        });

        this.isPostHogInitialized = true;
      }
    });
  }

  constructor(
    private ngZone: NgZone,
    private env: EnvService,
    private ssr: SsrService
  ) { }
}
